import { useTranslator } from 'translation/useTranslator';
import { IconType } from '../../../@types/icons';
import StatusIcon from './StatusIcon';

type DisabledProps = {
  tooltip?: string;
  size?: string;
  color?: string;
};
const DisabledIcon = ({ tooltip, size, color = 'error.main' }: DisabledProps) => {
  const translator = useTranslator();
  return (
    <StatusIcon
      tooltip={tooltip ?? translator.disabled()}
      size={size}
      color={color}
      icon={IconType.disabled}
    />
  );
};
export default DisabledIcon;
